/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Geography_RevenueInputs */

const vi_report_geography_revenue = /** @type {(inputs: Report_Geography_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doanh thu`)
};

/**

* @param {Report_Geography_RevenueInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_geography_revenue = /** @type {((inputs?: Report_Geography_RevenueInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Geography_RevenueInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_geography_revenue(inputs)
});